<template>
  <div>
    <div id="pnlButtonBar">
      <button
        @click="btnOpslaan"
        type="button"
        id="btnToevoegen"
        class="btn btn-primary btn-xs"
      >validate</button>
    </div>
    <div class="col-md-12">
      <div class="bs-example" data-example-id="inline-code">
        <div class="title">voorbeeld datum control</div>
        <XVbootstraprow label="datum">
          <template slot-scope="br">
            <XVdate
              v-model="testXVdate"
              name="testXVdate"
              class="test1"
              :error="errors.first('testXVdate')"
              v-validate="'XVDateDefault'"
            />
            <button @click="br.seterror('ddd',true)">test</button>
          </template>
        </XVbootstraprow>
      </div>
      <figure class="highlight">
        <pre><code class="language-html" data-lang="html"> 
            <h4>formatted date: {{formatteddate(testXVdate)}}</h4>               
          </code></pre>
      </figure>
    </div>
    <div class="col-md-12">
      <div class="bs-example" data-example-id="inline-code">
        <div class="title">na validator</div>
        <XVbootstraprow label="datum van:">
          <XVdate
            class="test2"
            v-model="eenXVdate"
            name="eenXVdate"
            ref="eenXVdate"
            :error="errors.first('eenXVdate')"
            v-validate="{XVDateDefault:true}"
          />
        </XVbootstraprow>
        <XVbootstraprow label="datum tot:">
          <XVdate
            class="test3"
            v-model="tweeXVdate"
            name="tweeXVdate"
            :error="errors.first('tweeXVdate') || comparedateError"
            v-validate="{XVDateDefault:true}"
          />
        </XVbootstraprow>
      </div>
      <figure class="highlight">
        <pre><code class="language-html" data-lang="html"> 
            <h4>van date: {{formatteddate(eenXVdate)}}</h4>
            <h4>tot date: {{formatteddate(tweeXVdate)}}</h4>               
          </code></pre>
      </figure>
    </div>
  </div>
</template>  

<script>
import { util } from 'pevueglobal'
import { isAfter } from 'date-fns'
export default {
  data: function() {
    return {
      errormessage: '',
      testXVdate: new Date('2019-12-15'),
      eenXVdate: new Date('2019-12-15'),
      tweeXVdate: new Date('2019-12-15'),
      testInput: 'hallo daar'
    }
  },
  computed: {
    comparedateError() {
      if (isAfter(this.eenXVdate, this.tweeXVdate)) {
        return 'datum kleiner dan begin datum'
      } else {
        return ''
      }
    }
  },
  methods: {
    btnOpslaan() {
      this.$validator.validateAll().then(result => {
        console.log(result)
        if (result) {
        }
      })
    },
    formatteddate(val) {
      return util.DateForDatabase(val)
    }
  },

  mounted() {}
}
</script>
<style scoped>
</style>

